var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CobVueSuggestion", {
    attrs: {
      items: _vm.items,
      minLen: 1,
      setLabel: _vm.setLabel,
      itemTemplate: _vm.ItemTemplate,
      inputClasses: "rm-task-assignee",
      wrapperClasses: "rm-task-assignee-search",
      placeholder: _vm.i18n.searchUser
    },
    on: {
      changed: _vm.inputChange,
      selected: _vm.itemSelected,
      enter: _vm.keyEnter,
      escape: _vm.keyEscape
    },
    model: {
      value: _vm.item,
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }